// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oV-z","smallCardRow":"pV-z","largeCardRow":"qV-z","productSearchRow":"rV-z","curatedRow":"sV-z"};